module.exports = __webpack_public_path__ + "img/responsible.9fd64d86.svg";